<template>
  <div class="room-footer">
    <footer-reassign
      v-if="assignToMyself"
      class="box-footer chat-input-section p-3 p-lg-4 border-top mb-0 justify-content-center"
      :room="room"
    />
    <footer-form v-else />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FooterReassign from './Footer/ReassignFooterRoomComponents'
import FooterForm from './Footer/FormFooterRoomComponents'

export default {
  name: 'RoomFooter',
  components: {
    FooterReassign,
    FooterForm,
  },
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
    assignToMyself() {
      return this.room?.user_id !== this.user?.id;
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
